import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Img from "gatsby-image";
import Icon, { IconName } from "../icon";
import DOMWindow from "../../util/dom-wrapper/window";
var getDimensions = function getDimensions(_ref) {
    var maxWidth = _ref.width, maxHeight = _ref.height, image = _ref.image;
    var width = 0;
    var height = 0;
    var maxImagewidth = image.width || maxWidth;
    if (image) {
        var aspectRatio = image.aspectRatio;
        if (aspectRatio >= 1) {
            width = Math.min(maxWidth, maxHeight * aspectRatio, maxImagewidth) * 0.8;
            height = width / aspectRatio;
        }
        else {
            height = Math.min(maxImagewidth / aspectRatio, maxHeight) * 0.8;
            width = height * aspectRatio;
        }
    }
    return {
        width: width,
        height: height
    };
};
var ImageModal = function ImageModal(_ref2) {
    var modalStatus = _ref2.modalStatus, closeModal = _ref2.closeModal, image = _ref2.image;
    var _useState = useState({
        width: 0,
        height: 0
    }), dimensions = _useState[0], setDimensions = _useState[1];
    var _useState2 = useState({
        width: DOMWindow.innerWidth(),
        height: DOMWindow.innerHeight()
    }), windowDimensions = _useState2[0], setWindowDimensions = _useState2[1];
    var modalCloseTimeout = 100;
    useEffect(function () {
        if (image) {
            var _dimensions = getDimensions(Object.assign({}, windowDimensions, {
                image: image.fluid
            }));
            setDimensions(_dimensions);
        }
    }, [image, windowDimensions]);
    useEffect(function () {
        var onResize = function onResize() {
            setWindowDimensions({
                width: DOMWindow.innerWidth(),
                height: DOMWindow.innerHeight()
            });
        };
        DOMWindow.addEventListener("resize", onResize, {
            once: false
        });
        return function () {
            return DOMWindow.removeEventListener("resize", onResize);
        };
    }, []);
    var modalStyle = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#151515bf"
        },
        content: {
            position: "static",
            border: "1px solid #929292",
            overflow: "auto",
            borderRadius: "4px",
            outline: "none",
            height: "auto",
            inset: "0",
            padding: "0"
        }
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: modalStatus,
        onRequestClose: closeModal,
        contentLabel: "Modal" // @ts-ignore
        ,
        style: modalStyle,
        closeTimeoutMS: modalCloseTimeout
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return closeModal();
        },
        className: "w-5 h-5 absolute rounded-full p-2 mr-2 box-content focus:outline-none",
        style: {
            top: "1.25rem",
            right: "0.25rem",
            backgroundColor: "#292929b3"
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.CLOSE,
        color: "#ccc"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "relative",
        style: dimensions
    }, image && image.fluid ? /*#__PURE__*/ React.createElement(Img, {
        fluid: image.fluid
    }) : ""));
};
export default ImageModal;
